// Phase 6 — Reports submenu (static mockup) migrated to shadcn/Tailwind.
//
// This is a non-functional placeholder screen (no dispatch/API) — it renders
// hardcoded sample figures. UI only: the MUI Grid/Table/Select + antd DatePicker
// become shadcn Cards, StatCards, a plain table and the shared DateRangePicker.
import { useState } from "react";
import { PackageCheck, Undo2 } from "lucide-react";
import { DateRange } from "react-day-picker";
import AppConstant from "../../Globals/AppConstants";
import { StatCard } from "../../shared/stat-card";
import { Card, CardContent, CardHeader, CardTitle } from "ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "ui/table";
import { cn } from "lib/utils";
import { DateRangePicker } from "../Reports/DateRangePicker";

const VERTICAL_MENU = ["Sales", "Stockes", "Customers"];

const ReportSubmenu = () => {
    const [range, setRange] = useState<DateRange | undefined>(undefined);
    const [active, setActive] = useState("Sales");

    return (
        <div className="mz h-full space-y-6 overflow-y-auto px-6 py-4">
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <h1 className="text-xl font-semibold text-foreground">{AppConstant?.menus?.report}</h1>
                <DateRangePicker value={range} onChange={setRange} disableFuture />
            </div>

            <div className="grid grid-cols-1 gap-6 md:grid-cols-[200px_1fr]">
                {/* Vertical menu */}
                <Card className="h-fit">
                    <CardContent className="p-2">
                        {VERTICAL_MENU.map((item) => (
                            <button
                                key={item}
                                type="button"
                                onClick={() => setActive(item)}
                                className={cn(
                                    "block w-full rounded-md px-3 py-2 text-left text-sm transition-colors",
                                    active === item
                                        ? "bg-primary/10 font-medium text-primary"
                                        : "text-muted-foreground hover:bg-muted hover:text-foreground"
                                )}
                            >
                                {item}
                            </button>
                        ))}
                    </CardContent>
                </Card>

                {/* Data */}
                <div className="space-y-6">
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                        <StatCard label={AppConstant?.soldItems} value="3000" caption="₹ 111111" icon={PackageCheck} />
                        <StatCard label={AppConstant?.returnedItems} value="3000" icon={Undo2} />
                    </div>

                    <div className="grid grid-cols-1 gap-6 lg:grid-cols-[220px_1fr]">
                        <Card className="h-fit">
                            <CardHeader className="pb-3">
                                <CardTitle className="text-sm">{AppConstant?.categories}</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <div className="flex items-center justify-between text-sm">
                                    <span className="text-foreground">Saree</span>
                                    <span className="tabular-nums text-muted-foreground">30</span>
                                </div>
                            </CardContent>
                        </Card>

                        <div className="overflow-hidden rounded-xl border">
                            <Table>
                                <TableHeader>
                                    <TableRow className="hover:bg-transparent">
                                        <TableHead>{AppConstant?.subCategory}</TableHead>
                                        <TableHead>{AppConstant?.count}</TableHead>
                                        <TableHead>{AppConstant?.amount}</TableHead>
                                    </TableRow>
                                </TableHeader>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>Saree</TableCell>
                                        <TableCell className="tabular-nums">10</TableCell>
                                        <TableCell className="tabular-nums">3000</TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ReportSubmenu;
